async function deriveKeyFromText(text: string) {
  const encoder = new TextEncoder();
  const keyMaterial = await crypto.subtle.digest(
    'SHA-256',
    encoder.encode(text),
  );
  return keyMaterial.slice(0, 16);
}

const generateSecretKey = async (key: string) => {
  const keyBuffer = await deriveKeyFromText(key);
  return crypto.subtle.importKey('raw', keyBuffer, { name: 'AES-GCM' }, false, [
    'encrypt',
    'decrypt',
  ]);
};

export async function encryptAES(plaintext: string, key: string) {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const secretKey = await generateSecretKey(key);
  const encrypted = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    secretKey,
    new TextEncoder().encode(plaintext),
  );
  return btoa(
    JSON.stringify({
      iv: Array.from(iv),
      data: Array.from(new Uint8Array(encrypted)),
    }),
  );
}

export async function decryptAES(encryptedJson: any, key: string) {
  const { iv, data } = JSON.parse(atob(encryptedJson));
  const secretKey = await generateSecretKey(key);
  const decrypted = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv: new Uint8Array(iv) },
    secretKey,
    new Uint8Array(data),
  );
  return new TextDecoder().decode(decrypted);
}
